module.exports = ".lista-conteudo-padrao {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 200px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/artefato/cadastro-operacao/cadastro-operacao.component.css
// module id = ./src/app/artefato/cadastro-operacao/cadastro-operacao.component.css
// module chunks = main